import React from 'react'
import NoContent from "./NoContent";
import HomePage from "@system/config/home-page";
import Helper from 'src/helper/Helper';

const Events = (props) => {
    const { eventsList, searchText, tab } = props;

    return (
        <>
            <div className="search-item-title text-uppercase">RECOMMENDED Events</div>
            {Object.keys(eventsList).length > 0 &&
                <>
                    <div className="search-artical-list">
                        {Object.keys(eventsList).length > 0 && Object.entries(eventsList).map((v, i) => (
                            <React.Fragment key={i}>
                                {i < 5 &&
                                    <a href={v[1]?.url} className="search-artical-list-item cursor-pointer">
                                        <div className="search-artical-list-item-info">
                                            <div className="search-artical-title">{v[1].name}</div>
                                            <div className="search-artical-desc">
                                                <div className='ellipses'>
                                                    {v[1].shortDescription}
                                                </div>
                                            </div>
                                            <div className="date-location-box">
                                                <div className="date-location-item">
                                                    <b>Date:&nbsp;</b> {Helper.dateFormatFromString(v[1].avnDate)}
                                                </div>
                                                <div className="date-location-item">
                                                    <b>Location:&nbsp;</b> {v[1].avnLocation}
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                }
                            </React.Fragment>
                        ))}
                    </div>
                    <a href={HomePage.makeHomeTabsListRouteURL(tab) + '&__c_HomePageContent=ALCT&__c_HomePageContentTabList=EVT&search=' + searchText }
                        className="text-center mt-auto pb-3 pt-3">
                        <div className="bs5 btn btn-sm btn-primary">VIEW ALL Event Results</div>
                    </a>
                </>
            }
            {Object.keys(eventsList).length === 0 &&
                <>
                    <NoContent />
                </>
            }
        </>
    )
}

export default Events